import React from 'react';
import { observer } from 'mobx-react';

import { RentalAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/rental/types';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';

import RentalsCardContent from './components/RentalsCardContent/RentalsCardContent';
import { useRentalsCard } from './hooks/useRentalsCard/useRentalsCard';

interface Props {
  rentalItem: RentalAsset;
  itemWidth: number;
  imageHeight: number;
}

function RentalsCard({ rentalItem, itemWidth, imageHeight }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    ariaLabel,
    handleRef,
    assetRating,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    handleLinkRef,
    isSeriesRecord,
    handleClickInfo,
    defaultImageUrl,
    isDisplayRating,
    backgroundImageUrl,
  } = useRentalsCard({ rentalItem, itemWidth, imageHeight });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={false}
      ariaLabel={ariaLabel}
    >
      <CardInner
        cardType='rental'
        url={backgroundImageUrl}
        name={rentalItem.title}
        defaultImageUrl={defaultImageUrl}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={false}
        contentOverlay={
          <RentalsCardContent
            isDisplayRating={isDisplayRating}
            assetRating={assetRating!}
            shouldDisplayPlayButton
            isAdult={isAdult}
          />
        }
      />
      <CardBubbleInfo
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        channelHasProgram
        isAdult={isAdult}
        title={title}
        isMosaicProgram={false}
        handleClickInfo={handleClickInfo}
        isLinkAsAsset={false}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={false}
      />
    </Card>
  );
}

export default observer(RentalsCard);
